import { Injectable } from '@angular/core';
import {
	CanActivate,
	ActivatedRouteSnapshot,
	RouterStateSnapshot,
	Router,
} from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { Location } from '@angular/common';
import { SettingsService } from './SettingsService';

@Injectable({
	providedIn: 'root',
})
export class RedirectGuard implements CanActivate {
	constructor(
		private http: HttpClient,
		private settings: SettingsService,
		private router: Router,
		private location: Location,
	) {}

	canActivate(
		_next: ActivatedRouteSnapshot,
		state: RouterStateSnapshot,
	): Observable<boolean> {
		const path = decodeURI(state.url.split('?')[0]);
		const lang = this.settings.currentAppLanguage;
		const _format = 'json';

		return this.http
			.get(`${this.settings.url}/api/redirect`, {
				params: { path, lang, _format },
			})
			.pipe(
				map((result: any) => {
					if (result?.redirect) {
						if (result?.routed) {
							this.router.navigate([result.redirect]);
						} else if (globalThis?.window) {
							globalThis.window.location.replace(result.redirect);
						}
						return false;
					}
					return true;
				}),
				catchError(() => of(true)),
			);
	}
}
